import React from "react";
import { StyledTableCell } from "../../../components/ShipmentSummary/components/SummaryGrid/SummaryGrid";
import {
  BACKGROUND_GRAY,
  GREEN_05,
  LIGHT_BACKGROUND_GRAY,
} from "../../../constants/css.constants";
import BaseTable from "../../../components/BaseTable/BaseTable";
import { formatNumbersWithCommas } from "../../../constants/utils";
import useEditRights from "../../../hooks/useEditRights";

type TotalBusinessModelTableProps = {
  data: number[][];
  horizontalHeaders: string[];
  monthsInFirstTwoSeasons: number;
  tab: string;
  verticalHeaders: string[];
};
const TotalBusinessModelTable = ({
  data,
  horizontalHeaders,
  monthsInFirstTwoSeasons,
  tab,
  verticalHeaders,
}: TotalBusinessModelTableProps) => {
  const { canEdit } = useEditRights();
  const isTB = tab.toLowerCase() === "tb";
  const isDisabled = isTB || !canEdit;
  const innerCell = (value: number, column: number) => (
    <StyledTableCell
      cssProperties={
        column < monthsInFirstTwoSeasons && isDisabled
          ? { backgroundColor: LIGHT_BACKGROUND_GRAY, color: "#000", fontSize: "1rem" }
          : column < monthsInFirstTwoSeasons
            ? { backgroundColor: GREEN_05, color: "black", fontSize: "1rem" }
            : { backgroundColor: BACKGROUND_GRAY, color: "#FFF", fontSize: "1rem" }
      }
      padding='none'
      size='small'
    >
      {formatNumbersWithCommas(value)}
    </StyledTableCell>
  );
  return (
    <BaseTable
      data={data}
      horizontalHeaders={horizontalHeaders}
      tab={tab}
      verticalHeaders={verticalHeaders}
      innerCell={innerCell}
    />
  );
};

export default TotalBusinessModelTable;
